var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.viewPendenciaLogin !== null)?_c(_vm.viewPendenciaLogin,{tag:"component",attrs:{"erros":_vm.errosAceiteContrato},on:{"finalizandoPendencia":_vm.finalizandoPendencia,"enviarNotificacao":_vm.obterNotificacao}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }